import axios from 'axios'

export default {
    async get(pageQueryId) {
        try{            
            const response = await axios.get(`UpdatesHistory/${pageQueryId}`)            
            return response
        }catch (error){
            console.log('UpdateHistory api get error')
            throw error
        }
    },
    async send(data) {
        try{            
            const response = await axios.post(`UpdatesHistory`, {
                item: data
            })            
            return response
        }catch (error){
            console.log('UpdateHistory api send error')
            throw error
        }
    }
}